import { EditorContent } from '@tiptap/vue-3';
import { MdTypography, MdIconLoader } from '@antiqua-dls/vue-components';
import ThumbsUp from 'src/components/icons/thumbs-up';
import ThumbsDown from 'src/components/icons/thumbs-down';
import { adobeCjaEventEmitter } from '../../../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES } from '../../../../../../../../modules/adobe-cja/constants'

export default {
  name: 'EditorBody',
  components: {
    EditorContent,
    MdTypography,
    MdIconLoader,
    ThumbsUp,
    ThumbsDown
  },
  props: {
    editor: {
      type: Object,
      required: true
    },
    diffEditor: {
      type: Object,
      required: true
    },
    isDiffView: {
      type: Boolean,
      required: true
    },
    isAiResponseLoading: {
      type: Boolean,
      required: true
    },
    aiSuggestedText: {
      type: String,
      required: true
    },
    characterCount: {
      type: Object,
      required: true
    },
    feedbackGiven: {
      type: [String, Boolean],
      default: false
    },
    updateFeedback: {
      type: Function,
      required: true
    },
    feedbackId: {
      type: String,
      required: true
    },
    assetType: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const updateFeedbackFunction = (feedback) => {
      props.updateFeedback({
        feedbackId: props.feedbackId,
        feedback: feedback
      });

      const linkName = feedback === 'liked' ? 'feedbackType_thumbs_up' : 'feedbackType_thumbs_down';
      
      const analyticsPayload = {
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.AI_ASSISTANT,
          linkSection: `${props.assetType}_description`,
          linkName: linkName,
          linkType: LINK_TYPES.ICON_CLICK
        }
      };
      adobeCjaEventEmitter(analyticsPayload);
    }
    return {
      updateFeedbackFunction
    };
  }
};
